/**
 * The games top bar: the same thin bar sits at the top of every one of
 * Bennett's games, so they feel like one site. Spellweave has no accounts,
 * so it holds only the link back to the games hub. The bar sits above the
 * arena, never over it: styles.css moves the canvas, overlays and buttons
 * down by --top-bar.
 */

import { el } from './dom.js';

/** The games hub. The one place its address lives. */
export const ARCADE_URL = 'https://games.bennettdishman.com/';

export function mountTopBar(): HTMLElement {
  const bar = el('nav', { class: 'top-bar', 'aria-label': 'Games' },
    el('a', { class: 'top-bar-home', href: ARCADE_URL },
      el('span', { 'aria-hidden': 'true' }, '◂'), ' All games',
    ),
  );
  document.body.prepend(bar);
  return bar;
}
